{
  "REGISTER": {
    "TRY_WOOT": "Создать новый аккаунт",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Регистрация",
    "TESTIMONIAL_HEADER": "Все, что нужно сделать, это один шаг для продвижения вперед",
    "TESTIMONIAL_CONTENT": "Вы находитесь на расстоянии всего одного шага от привлечения своих клиентов, удержав их и находя новые.",
    "TERMS_ACCEPT": "Создавая учетную запись, вы соглашаетесь с нашими <a href=\"https://www.chatwoot.com/terms\">Т и С</a> и <a href=\"https://www.chatwoot.com/privacy-policy\">политикой конфиденциальности</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Регистрация через Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Название компании",
      "PLACEHOLDER": "Введите название вашей компании например Wayne Enterprises",
      "ERROR": "Название компании слишком короткое."
    },
    "FULL_NAME": {
      "LABEL": "Полное имя",
      "PLACEHOLDER": "Введите ваше полное имя. Например: Брюс Уэйн",
      "ERROR": "Имя слишком короткое."
    },
    "EMAIL": {
      "LABEL": "Рабочий email",
      "PLACEHOLDER": "Введите ваш рабочий адрес электронной почты. Например: bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Пожалуйста, введите действительный адрес электронной почты."
    },
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль",
      "ERROR": "Пароль слишком короткий.",
      "IS_INVALID_PASSWORD": "Пароль должен содержать хотя бы одну заглавную букву, одну строчную букву, 1 цифру и 1 специальный символ.",
      "REQUIREMENTS_LENGTH": "Длина не менее 6 символов",
      "REQUIREMENTS_UPPERCASE": "Минимум одна заглавная буква",
      "REQUIREMENTS_LOWERCASE": "Минимум одна строчная буква",
      "REQUIREMENTS_NUMBER": "Минимум одно число",
      "REQUIREMENTS_SPECIAL": "Минимум один специальный символ"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Подтвердите пароль",
      "PLACEHOLDER": "Подтвердите пароль",
      "ERROR": "Пароли не совпадают."
    },
    "API": {
      "SUCCESS_MESSAGE": "Регистрация прошла успешно",
      "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз."
    },
    "SUBMIT": "Создать новый аккаунт",
    "HAVE_AN_ACCOUNT": "Уже есть аккаунт?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Повторно отправить письмо с подтверждением",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
